import { NavigateFunction } from "react-router-dom";
import { ROUTE_PATHS } from "../../../../routes/paths";
import { VendorSignupFormData } from "./config";
import { VendorSignupResponseData } from "./types";

export function handleVendorSignupSuccess(
  userData: VendorSignupResponseData,
  navigate: NavigateFunction
): void {
  if (userData.profileId) {
    navigate(ROUTE_PATHS.MY_PROFILE);
  } else {
    navigate(ROUTE_PATHS.AUTH.SIGNUP_MORE_ABOUT_VENDOR_COMPANY);
  }
}

export function getVendorSignupPayload(
  data: VendorSignupFormData
): {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  role: string;
} {
  return {
    email: data.email.toLowerCase(),
    firstName: data.firstName,
    lastName: data.lastName,
    password: data.password,
    role: "vendor",
  };
}
